"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactstrap = require("reactstrap");

var _classNames2 = _interopRequireDefault(require("../../util/classNames"));

require("./ButtonIcon.scss");

require("./ButtonIconDark.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ButtonIcon = function ButtonIcon(props) {
  var _classNames;

  var classes = (0, _classNames2["default"])((_classNames = {
    disabled: props.disabled
  }, _defineProperty(_classNames, props.size, props.size), _defineProperty(_classNames, props.shape, true), _defineProperty(_classNames, props.color, true), _classNames));

  var onClick = function onClick(e) {
    !props.disabled && props.onClick(e);
  };

  var tooltipRef = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement("button", {
    id: props.id,
    className: 'gcl-btnIcon ' + classes,
    onClick: onClick,
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + props.icon + ' ' + props.size,
    ref: tooltipRef
  }), props.tooltip != null && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: tooltipRef,
    delay: {
      show: 300,
      hide: 100
    },
    placement: "top",
    trigger: "hover",
    boundariesElement: "window"
  }, props.tooltip));
};

ButtonIcon.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  shape: _propTypes["default"].oneOf(['square', 'circle']),
  size: _propTypes["default"].oneOf(['small', 'large', '']),
  icon: _propTypes["default"].string,
  id: _propTypes["default"].string,
  color: _propTypes["default"].oneOf(['primary', 'secondary']),
  tooltip: _propTypes["default"].string
};
ButtonIcon.defaultProps = {
  onClick: function onClick() {
    return console.warn('no function was assigned as prop');
  },
  disabled: false,
  shape: 'square',
  size: '',
  color: 'secondary'
};
var _default = ButtonIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/ButtonIcon/ButtonIcon.js
// module id = 421
// module chunks = 0